import React from 'react';

const logos = [
  {
    name: 'Fishbuddy',
    src: 'https://customer-assets.emergentagent.com/job_upscale-blue/artifacts/fg3f65j9_Fishbuddy-by-fiskher_Liggende.png',
  },
  {
    name: 'Skida',
    src: 'https://customer-assets.emergentagent.com/job_03e046c2-c54d-47da-b894-273efa8f8020/artifacts/dmpd42y4_LogoIndigo-%402x.png',
  },
  {
    name: 'Tyri',
    src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_03e046c2-c54d-47da-b894-273efa8f8020/artifacts/8ynaw5gi_Tyri%20app%20logo.png',
  },
  {
    name: 'Opera Mini',
    src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_03e046c2-c54d-47da-b894-273efa8f8020/artifacts/taefww3a_Opera-Mini-Cover.png',
  },
  {
    name: 'Mobile Ears',
    src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_03e046c2-c54d-47da-b894-273efa8f8020/artifacts/gjd82n33_Mobile%20Ears%20logo.png',
  },
  {
    name: 'Opera Max',
    src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_03e046c2-c54d-47da-b894-273efa8f8020/artifacts/wqbuosrk_opera-max-logo-640.png',
  },
  {
    name: 'Settle',
    src: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_03e046c2-c54d-47da-b894-273efa8f8020/artifacts/1d3qbzvg_Settle%20app%20logo.webp',
  },
];

const LogoStrip = () => {
  return (
    <section
      data-testid="app-growth-logo-strip"
      className="py-14 px-4 sm:px-6 lg:px-8 bg-white border-y border-gray-100"
    >
      <div className="max-w-7xl mx-auto">
        <p
          data-testid="logo-strip-label"
          className="text-center text-sm uppercase tracking-widest text-gray-500 font-semibold mb-10"
        >
          Trusted by app teams shipping to millions of users
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4 items-stretch">
          {logos.map((logo) => (
            <div
              key={logo.name}
              data-testid={`logo-${logo.name.toLowerCase().replace(/\s+/g, '-')}`}
              className="group h-20 sm:h-24 rounded-xl bg-white border border-gray-100 flex items-center justify-center p-4 shadow-sm hover:shadow-md hover:border-blue-200 transition-all duration-300"
              title={logo.name}
            >
              <img
                src={logo.src}
                alt={`${logo.name} logo`}
                className="max-h-full max-w-full object-contain grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogoStrip;
